import React from 'react'

import AgreeDisagreeQuestion from '../../../../_global/AgreeDisagreeQuestion';

interface CurrentResidentProps {
  handleChange: React.Dispatch<React.SetStateAction<boolean | null>>
  isCurrentResident: boolean | null
}

const CurrentResident = ({ handleChange, isCurrentResident }: CurrentResidentProps) => {
  return (
    <AgreeDisagreeQuestion
      title="Are you current Resident of the United States?"
      onAgreeClick={() => handleChange(true)}
      onDisagreeClick={() => handleChange(false)}
      status={isCurrentResident}
    />
  )
}

export default CurrentResident
